import { render, staticRenderFns } from "./Prop.vue?vue&type=template&id=05e185cc&"
import script from "./Prop.vue?vue&type=script&lang=js&"
export * from "./Prop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports